import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import LeftRightContent from '../../components/LeftRightContent';
import RequestDataForm from '../../components/RequestDataForm';
import Title from '../../components/Title';

import {sendDataRequest} from './requestDataSlice';
import MessageFeature from '../message/MessageFeature';
import {showErrorMessage, showSuccessMessage} from '../message/messageSlice';
import {uploadFileAsync} from '../file/fileSlice';
import {tenantState} from '../tenant/tenantSlice';

import {getObjectProp, dateToDisplayFormat} from '../../utils/helpers';

function RequestDataFeature() {
  const dispatch = useDispatch();
  const data = useSelector(tenantState);

  const handleSubmit = payload =>
    new Promise((resolve, reject) => {
      const values = {...payload, id_proof: payload.id_proof[0].id};
      return dispatch(sendDataRequest(values)).then(({payload: response}) => {
        const {error, message} = response;
        if (error || message) {
          const errorMsg =
            getObjectProp(error, 'message') ||
            getObjectProp(message, 'message') ||
            'An unexpected error has occured, please try again.';
          dispatch(showErrorMessage(errorMsg));
          return reject(response);
        }
        dispatch(
          showSuccessMessage(
            'Your request has been submitted successfully. Thank you!'
          )
        );
        return resolve(response);
      });
    });

  const handleAttachmentUpload = (files, callback) =>
    new Promise((resolve, reject) => {
      const [file] = files;
      uploadFileAsync(file, file.filename.split('.')[0], '', true)
        .then(async response => {
          callback.call(null, [{...file, id: response.id}]);
          resolve(response);
        })
        .catch(e => {
          reject(e);
        });
    });

  const initialValues = {
    first_name: getObjectProp(data, 'profile.first_name'),
    middle_name: getObjectProp(data, 'profile.middle_names'),
    last_name: getObjectProp(data, 'profile.last_name'),
    email: getObjectProp(data, 'profile.email'),
    phone: getObjectProp(data, 'profile.mobile'),
    dob: dateToDisplayFormat(getObjectProp(data, 'profile.dob')),
  };

  return (
    <>
      <Title text="Information Request - Tenant Portal" />
      <MessageFeature />
      <LeftRightContent
        bgcolor="light"
        heading="Request My Data"
        content={
          <RequestDataForm
            initialValues={initialValues}
            onIdUpload={handleAttachmentUpload}
            onSubmit={handleSubmit}
          />
        }
      />
    </>
  );
}

export default RequestDataFeature;
